export default __webpack_public_path__ + "static/msi-7d2e35de6752443bf99a7d848315cd40.svg";